import { Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SiteLayout } from "@/components/site/SiteLayout";
import { I18nProvider } from "@/i18n";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import { AnalyticsPage } from "@/pages/admin/AnalyticsPage";
import { DashboardPage } from "@/pages/admin/DashboardPage";
import { LeadsPage } from "@/pages/admin/LeadsPage";
import { MediaPage } from "@/pages/admin/MediaPage";
import { SeoPage } from "@/pages/admin/SeoPage";
import { SettingsPage } from "@/pages/admin/SettingsPage";
import { VehicleEditorPage } from "@/pages/admin/VehicleEditorPage";
import { VehiclesPage } from "@/pages/admin/VehiclesPage";
import { CatalogPage } from "@/pages/CatalogPage";
import { HomePage } from "@/pages/HomePage";
import { NotFoundPage } from "@/pages/NotFoundPage";

export default function App() {
  return (
    <I18nProvider>
      <Routes>
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<DashboardPage />} />
          <Route path="vehicles" element={<VehiclesPage />} />
          <Route path="vehicles/:id" element={<VehicleEditorPage />} />
          <Route path="leads" element={<LeadsPage />} />
          <Route path="media" element={<MediaPage />} />
          <Route path="seo" element={<SeoPage />} />
          <Route path="analytics" element={<AnalyticsPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Route>
        <Route element={<SiteLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/catalog" element={<CatalogPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
      <Toaster theme="dark" position="top-right" />
    </I18nProvider>
  );
}
